<!--Hello, user-->
<div class="row h-100">
  <div class="col-md-5 my-auto">
    <div>
      <h1>Hello, {{userName}} </h1>
    </div>
  </div>
</div>

<!--Reminder-->
<div class="card card-narrow-1 mb-4" *ngIf="ReminderAnnouncement.length > 0 && ReminderAnnouncement[0].title">
  <div class="card-body p-0 bg-light-cyan">
    <div class="row px-4">
      <div class="col">
        <ngb-carousel id="c2" [showNavigationIndicators]="ReminderAnnouncement.length > 1">
          <ng-template ngbSlide *ngFor="let announcement of ReminderAnnouncement">
            <div class="announcement-container">
              <div class="pt-4 pb-2">
                <h4>{{ announcement.title }}</h4>
              </div>
              <div class="pb-4">
                <div id="detail-{{announcement.contentDetailID}}" [innerHtml]="announcement.details"></div>
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </div>
    </div>
  </div>
</div>

<!--Body-->
<div class="row m-t-10" *ngIf="allowContentFeatures">

  <!--Featured Contents-->
  <div class="col-12" *ngIf="contentFeatures && !contentDisplayMore">
    <div class="row">
      <div *ngFor="let detail of contenFeatureDetailList" [class]="getContentLayout(detail)">
        <div class="imageContainer">
          <img id="Photo-{{detail.contentDetailID}}" [src]="imageUrl(detail.docFileName)" alt="" class="imgFeature" />
          <div class="content" style="cursor: pointer;" (click)="displayViewMore(detail)">
            <span style="font-size:x-large"><i class="fa fa-caret-right pe-10"></i><b>{{detail.title}}</b></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--hidden-->
  <div class="col" *ngIf="!contentFeatures && !contentDisplayMore" hidden>
    <div class="card card-narrow-1 h-100">
      <div class="card-body" [style]="setBackgroundStyle('#fef1d2')">
        <div *ngIf="contenDetailList.length == 0">
          No Content Detail Available
        </div>
        <div *ngFor="let detail of contenDetailList">
          <div class="row pb-20">
            <div class="col-5 pt-10" *ngIf="detail.docFileName">
              <img id="Photo" [src]="imageUrl(detail.docFileName)" alt="" style="height:auto;width:100%" />
            </div>
            <div class="col-7" style="width:90%;cursor: pointer;" (click)="displayContentDetail(detail)">
              <span><i class="fa fa-caret-right pe-10"></i><b>{{detail.title}}</b></span>
            </div>
          </div>

          <div *ngIf="detail.details==null">
            No Content Detail Available
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Latest News Details-->
  <div class="col-12" *ngIf="!contentFeatures && !contentDisplayMore">
    <div class="card card-narrow-1 h-100" style="border-right: 5px solid lightgrey;">
      <div class="card-body bg-white">

        <div class="row h-100">

          <!--Left pane: Menu-->
          <div class="col bg-gray-100 pb-4">
            <div *ngFor="let detail of contenDetailList">
              <div class="row pb-4">
                <div class="col-5 pt-2" *ngIf="detail.docFileName != null">
                  <img id="Photo" [src]="imageUrl(detail.docFileName)" alt="" style="height:auto;width:100%" />
                </div>
                <div class="col-5 pt-2" *ngIf="detail.docFileName == null">
                  <img id="Photo" src="assets/images/no-image-available.png" alt="" style="height:auto;width:70%" />
                </div>
                <div class="col-7 pt-3 fs-6 flex-wrap d-flex align-items-center" style="cursor: pointer;" (click)="displayContentDetail(detail)">
                  <span><i class="fa fa-caret-right pe-2"></i><b> {{detail.title}}</b></span>
                </div>
              </div>
              <div class="row" *ngIf="detail.details==null">
                No Content Detail Available
              </div>
            </div>
          </div>

          <!--Right pane: Content-->
          <div class="col-8">
            <div class="row pb-4">
              <div class="col-4 pt-2" *ngIf="contenDetail.docFileName">
                <img id="Photo" [src]="imageUrl(contenDetail.docFileName)" alt="" style="height:auto;width:100%" />
              </div>
              <div class="col pb-3">
                <div class="row m-2" style="font-size:35px; font-weight:900">
                  {{contenDetail.title}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col pb-3">

                <div class="row m-1">
                  <div id="detail-{{contenDetail.contentDetailID}}" [innerHtml]="contenDetail.details"></div>
                </div>
                <div class="row m-1 ps-2">
                  <div class="right col" *ngIf="contenDocumentList.length > 0 && contenDetail.details!=null && !contentOnLoad">
                    <button id="btnDownload" (click)="displayDetailDownload(contenDetail)" type="button" class="btn btn-primary" style="min-width:90px;">Download</button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

      <!--Back To the homepage-->
      <div title="To the homepage" role="button" (click)="displayFeatures()" class="text-primary position-absolute fixed-bottom ms-4 mb-3 fw-bolder">
        <span><i class="fa fa-caret-left pe-2"></i>To the homepage</span>
      </div>

    </div>
  </div>

  <!--Featured Content Details-->
  <div class="col" *ngIf="contentDisplayMore">
    <div class="card card-narrow-1 h-100" style="border-right: 5px solid lightgrey;">
      <div class="card-body bg-white">

        <div *ngIf="contenDetail.details==null">No Content Detail Available</div>

        <!--Title and image-->
        <div class="row pb-3">
          <div class="col-4 pt-2" *ngIf="contenDetail.docFileName">
            <img id="Photo" [src]="imageUrl(contenDetail.docFileName)" alt="" style="height:auto;width:100%" />
          </div>
          <div class="col pb-3">
            <div class="row m-2" style="font-size:35px; font-weight:900">
              {{contenDetail.title}}
            </div>
          </div>
        </div>

        <!--Content-->
        <div class="row">
          <div class="col pb-3 ps-1">
            <div class="row m-2">
              <div id="detail-{{contenDetail.contentDetailID}}" [innerHtml]="contenDetail.details"></div>
            </div>
            <div class="row m-2">
              <div class="right col" *ngIf="contenDocumentList.length > 0 && contenDetail.details!=null && !contentOnLoad">
                <button id="btnDownload" (click)="displayDetailDownload(contenDetail)" type="button" class="btn btn-primary" style="min-width:90px;">Download</button>
              </div>

            </div>
          </div>
        </div>

        <!--Back To the homepage-->
        <div title="To the homepage" role="button" (click)="displayFeatures()" class="text-primary position-absolute fixed-bottom ms-4 mb-3 fw-bolder">
          <span><i class="fa fa-caret-left pe-2"></i>To the homepage</span>
        </div>

      </div>
    </div>
  </div>


</div>

